import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7850_501864)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M59 97.5V37.5C59 36.9477 59.4477 36.5 60 36.5C60.5522 36.5 61 36.9477 61 37.5V97.5C61 98.0523 60.5522 98.5 60 98.5C59.4477 98.5 59 98.0523 59 97.5Z",
				fill: "url(#paint0_linear_7850_501864)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.4961 13.7311C71.0589 8.8512 78.9243 9.2699 83.5771 13.9226C88.2308 18.5762 88.6475 26.4407 83.7695 31.0163L83.5332 31.2311C79.3631 34.9228 73.4258 36.719 68.6455 37.6061C66.2372 38.0531 64.0828 38.2758 62.5302 38.3874C61.7535 38.4432 61.1252 38.4719 60.6894 38.486C60.4719 38.4931 60.3022 38.496 60.1855 38.4977C60.1272 38.4986 60.0818 38.4995 60.0507 38.4997H60.0009C59.7357 38.4997 59.4805 38.3943 59.2929 38.2067C59.129 38.0428 59.0277 37.828 59.0048 37.5993L59 37.5V37.4489C59.0002 37.4179 59.001 37.3731 59.0019 37.3151C59.0037 37.1984 59.0076 37.0281 59.0146 36.8102C59.0287 36.3744 59.0563 35.7463 59.1123 34.9694C59.2241 33.4168 59.4477 31.2625 59.8955 28.8542C60.7843 24.0743 62.5831 18.1375 66.2812 13.9675L66.4961 13.7311ZM82.163 15.3366C78.1335 11.3072 71.4384 11.1486 67.7812 15.2917L67.7793 15.2936C64.4473 19.05 62.7311 24.5476 61.8623 29.2204C61.4312 31.5387 61.2152 33.616 61.1074 35.113C61.0691 35.644 61.0461 36.1013 61.0302 36.4694C61.3983 36.4536 61.8556 36.4314 62.3867 36.3933C63.8838 36.2856 65.9617 36.0696 68.2802 35.6394C72.9532 34.7722 78.4506 33.0593 82.207 29.7341L82.583 29.3815C86.339 25.6466 86.066 19.2396 82.163 15.3366Z",
				fill: "url(#paint1_linear_7850_501864)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.4225 13.9226C41.1491 9.19595 49.1912 8.83903 53.7184 13.9675C57.4168 18.1375 59.2153 24.0741 60.1042 28.8542C60.552 31.2625 60.7755 33.4168 60.8874 34.9694C60.9433 35.7463 60.9719 36.3744 60.986 36.8102C60.993 37.0281 60.9959 37.1984 60.9977 37.3151C60.9986 37.3731 60.9994 37.4179 60.9997 37.4489L61 37.5L60.9948 37.5993C60.972 37.828 60.8707 38.0428 60.7067 38.2067C60.5427 38.3707 60.328 38.472 60.0993 38.4948L59.9997 38.4997H59.9489C59.9179 38.4995 59.8731 38.4986 59.8151 38.4977C59.6984 38.496 59.5281 38.4931 59.3102 38.486C58.8744 38.4719 58.2463 38.4433 57.4694 38.3874C55.9169 38.2758 53.7632 38.053 51.3551 37.6061C46.7241 36.7468 41.0071 35.0345 36.8629 31.572L36.4665 31.2311C31.3405 26.6906 31.6951 18.65 36.4225 13.9226ZM52.2194 15.2917C48.5622 11.1485 41.8661 11.307 37.8366 15.3366C33.8078 19.3653 33.6471 26.0621 37.7926 29.7341L38.1501 30.0407C41.8919 33.1652 47.1924 34.7992 51.7194 35.6393C54.0379 36.0696 56.1158 36.2856 57.6129 36.3933C58.144 36.4314 58.6013 36.4536 58.9694 36.4694C58.9535 36.1013 58.9305 35.644 58.8922 35.113C58.7844 33.616 58.5694 31.5386 58.1383 29.2204C57.2694 24.5475 55.5524 19.05 52.2204 15.2936L52.2194 15.2917Z",
				fill: "url(#paint2_linear_7850_501864)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M104 41.25C104 39.7312 102.769 38.5 101.25 38.5H18.75C17.2312 38.5 16 39.7312 16 41.25V56.25C16 57.7688 17.2312 59 18.75 59H101.25C102.769 59 104 57.7688 104 56.25V41.25ZM106 56.25C106 58.8734 103.873 61 101.25 61H18.75C16.1266 61 14 58.8734 14 56.25V41.25C14 38.6266 16.1266 36.5 18.75 36.5H101.25C103.873 36.5 106 38.6266 106 41.25V56.25Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.5 93.75V60C21.5 59.4477 21.9477 59 22.5 59C23.0523 59 23.5 59.4477 23.5 60V93.75C23.5 94.4793 23.7899 95.1786 24.3057 95.6943C24.8214 96.2101 25.5207 96.5 26.25 96.5H93.75C94.4793 96.5 95.1786 96.2101 95.6943 95.6943C96.2101 95.1786 96.5 94.4793 96.5 93.75V60C96.5 59.4477 96.9477 59 97.5 59C98.0523 59 98.5 59.4477 98.5 60V93.75C98.5 95.0098 97.9992 96.2176 97.1084 97.1084C96.2176 97.9992 95.0098 98.5 93.75 98.5H26.25C24.9902 98.5 23.7824 97.9992 22.8916 97.1084C22.0008 96.2176 21.5 95.0098 21.5 93.75Z",
				fill: "#14151F"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7850_501864",
			x1: 32.7485,
			y1: 98.5,
			x2: 99.4586,
			y2: 88.0303,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E45D96"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7850_501864",
			x1: 32.7485,
			y1: 98.5,
			x2: 99.4586,
			y2: 88.0303,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E45D96"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_7850_501864",
			x1: 32.7485,
			y1: 98.5,
			x2: 99.4586,
			y2: 88.0303,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E45D96"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7850_501864",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 120,
				height: 120,
				fill: "white"
			})
		})
	] })]
});
export default SvgGiftBig;
